import NoProductImage from './NoProductImage'

export default function ProductUnavailable() {
	return (
		<div className="flex flex-col pb-6 gap-x-8">
			<div className="flex gap-x-4">
				<div className="md:mt-6 md:ml-4">
					<NoProductImage classNames="p-6 bg-gray-100" iconSize="fa-3x" />
				</div>

				<div className="flex flex-col justify-center mr-4 gap-y-2">
					<h3 className="text-sm font-medium">Product Unavailable</h3>
					<p className="text-xs font-light">Product is currently not available</p>
				</div>
			</div>

			<div className="space-y-8 mt-12">
				<div className="bg-gray-100 w-full h-12 rounded" />
				<div className="bg-gray-100 w-full h-24 rounded" />
				<div className="bg-gray-100 w-full h-24 rounded" />
			</div>
		</div>
	)
}
